export const SLOT_EVENT_DETAILS_HEADER = 'header'
export const SLOT_EVENT_DETAILS_CONTENT = 'details'

export const SLOT_EVENT_DETAILS_HEADER_ID = 'c9fa4cb6-396e-4d66-9624-0716f5b01f4a'
export const SLOT_EVENT_DETAILS_CONTENT_ID = '558afc1d-0369-4366-9418-027c9d4b99db'
